<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-spreadsheet-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.171 2a2 2 0 011.415.586l5.828 5.831A2 2 0 0142 9.831V44a2 2 0 01-2 2H8a2 2 0 01-2-2V4a2 2 0 012-2h26.171zM32 6H10v36h28V12.038l-5 .001a1 1 0 01-1-1L31.999 6zM33 16a2 2 0 012 2v17a2 2 0 01-2 2H15a2 2 0 01-2-2V18a2 2 0 012-2h18zm-13 9.497h-3.4V33.4l3.399-.001.001-7.902zm11.399 0H23v7.902l8.4.001-.001-7.903zM31.4 19.6H16.6v2.897h14.799L31.4 19.6z"/></svg>
</template>
<script>

export default {
  name: 'IconSpreadsheetAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
